/* eslint-disable @typescript-eslint/no-explicit-any */
import { type FormikErrors } from 'formik'
import {
  useMemo,
  type DetailedHTMLProps,
  type InputHTMLAttributes,
} from 'react'
export interface FormTextArea {
  placeholder?: string
  className?: string
  isError?:
    | string
    | false
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined
  id?: string
  name?: string
  children?: JSX.Element[] | JSX.Element
  alert?: boolean
  rows?: number
  value?: string | null
  icon?: JSX.Element
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export function FormTextArea({
  isError = false,
  className = '',
  rows = 3,
  alert = false,
  children,
  icon,
  name = '',
  placeholder = '',
  id = '',
  value,
  onChange = () => true,
}: FormTextArea &
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
  const helperChild = useMemo(
    () =>
      children &&
      ('filter' in children
        ? children.filter(f => f.type?.displayName === 'FormTextHelper')
        : (children.type?.displayName === 'FormTextHelper' && [children]) ||
          []),
    [children]
  )
  const errorChild = useMemo(
    () =>
      children &&
      ('filter' in children
        ? children.filter(f => f.type?.displayName === 'FormTextRequire')
        : (children.type?.displayName === 'FormTextRequire' && [children]) ||
          []),
    [children]
  )
  // Default width is 100% , height is 40px
  return (
    <>
      <textarea
        name={name}
        id={id}
        value={value}
        rows={rows}
        placeholder={placeholder}
        onChange={onChange}
        className={`w-full resize-none ${className} border
         p-3
        shadow-none placeholder:text-fieldInput focus:border-gray focus:shadow-none
        focus:outline-none focus:ring-0 ${
          isError ? 'border-states-error focus:ring-gray-light' : 'border-gray'
        }`}
      />
      {icon && icon}
      {alert && (
        <div className={`${isError && errorChild && 'pt-2'}`}>
          {isError && errorChild}
          {helperChild}
        </div>
      )}
    </>
  )
}

export default FormTextArea
